import PostButton from "PFComponents/post_button/post_button";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import CreatePost from "./create_post";

const Post = ({ profile, postTask, fetchActivities, tab }) => {
  const { t } = useTranslation("feed");

  const [showCreatePost, setShowCreatePost] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    postTask && setShowCreatePost(true);
    setIsEdit(true);
  }, [postTask]);

  return (
    <div>
      <PostButton
        profile={profile}
        text={t("post.shareThoughtsAndLinks")}
        handleClick={() => {
          setShowCreatePost(true);
          setIsEdit(false);
        }}
      />
      {showCreatePost && (
        <CreatePost
          handleClose={() => setShowCreatePost(false)}
          profile={profile}
          postTask={postTask}
          fetchActivities={fetchActivities}
          tab={tab}
          isEdit={isEdit}
        />
      )}
    </div>
  );
};

Post.propTypes = {
  profile: PropTypes.shape({
    avatar: PropTypes.shape({
      thumbnail_url: PropTypes.string
    })
  }),
  postTask: PropTypes.object,
  fetchActivities: PropTypes.func,
  tab: PropTypes.string
};

export default Post;
